var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.256 14H3a.5.5 0 01-.5-.5v-11A.5.5 0 013 2h10a.5.5 0 01.5.5v5.612A4.5 4.5 0 008.256 14z",
    fill: "#0FD683"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.256 14v.5h.707l-.236-.667-.47.167zM13.5 8.112l-.11.487.61.139v-.626h-.5zM3 14.5h5.256v-1H3v1zm-1-1a1 1 0 001 1v-1H2zm0-11v11h1v-11H2zm1-1a1 1 0 00-1 1h1v-1zm10 0H3v1h10v-1zm1 1a1 1 0 00-1-1v1h1zm0 5.612V2.5h-1v5.612h1zm-1.5.388c.306 0 .604.034.89.1l.22-.976A5.014 5.014 0 0012.5 7.5v1zm-4 4a4 4 0 014-4v-1a5 5 0 00-5 5h1zm.227 1.333A3.993 3.993 0 018.5 12.5h-1c0 .584.1 1.145.285 1.667l.942-.334z",
    fill: "#0FD683"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5h6M5 8h3",
    stroke: "#fff",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.094l1.667 1.75 3.333-3.5",
    stroke: "#0FD683",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/FollowUp.f7198821.svg";
export { SvgFollowUp as ReactComponent };